import { TMultiSelectItem } from "@centricsoftware/design-system";
import { cnl } from "c8-platform";
import { goToDialogAggregateStore } from "csi/middleware/goToDialog/goToDialogService";
import { StoreNames } from "csi/store/Names";
import { createContext, useContext } from "react";
import { GoToDialogSave, OnLoadOptions, SelectStoreBase } from "./SelectStoreBase";

export class MultiSelectStore extends SelectStoreBase {
	/** value representing the transientInfo.value of the multi select */
	multiSelectValue: string[] = [];

	/** onChange handler for the multi select */
	updateMultiSelectValue = (value: string[]): void => {
		this.multiSelectValue = value;
	};

	/** callback when list action is clicked */
	onListActionClick = (): void => {
		const { aggregateStore, aggregateStore: { aggregateStoreParams }, label, multiSelectValue, goToDialogSaveMulti, invalidItems } = this;
		goToDialogAggregateStore(
			aggregateStore,
			aggregateStoreParams.sourceUrl,
			multiSelectValue,
			invalidItems,
			true,
			label,
			goToDialogSaveMulti,
		);
	};

	/** update the multiSelectValue so that the changes will be reflected in the select component once user saves the results from "GoToDialog" */
	goToDialogSaveMulti = (urls: cnl[]): void => {
		this.goToDialogSave(urls);
		this.multiSelectValue = urls;
	};

	constructor(aggregateStore: StoreNames, onLoadOptions: OnLoadOptions, label: string, goToDialogSave?: GoToDialogSave, options?: TMultiSelectItem[], value?: string[]) {
		super(aggregateStore, onLoadOptions, label, goToDialogSave, null, options);
		this.multiSelectValue = value;
	}
}

export const MultiSelectStoreContext = createContext<MultiSelectStore>(undefined);
export const useMultiSelectStore = (): MultiSelectStore => useContext(MultiSelectStoreContext);